<template>
  <div id="page-voyage-history-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-end mb-base">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  totalVoyageHistory - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : totalVoyageHistory
                }}
                / {{ totalVoyageHistory }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="onChangePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="space-between"
          vs-w="6"
        >
          <vs-col vs-w="5">
            <label>操船者絞り込み</label>
            <v-select
              v-model="searchUserIds"
              multiple
              :closeOnSelect="false"
              :clearable="false"
              :options="optionUsers"
              name="searchUserIds"
              class="w-full pr-4"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            >
              <template v-slot:no-options>操船者が見つかりません。</template>
            </v-select>
          </vs-col>
          <vs-col vs-w="5">
            <label>船舶絞り込み</label>
            <v-select
              v-model="searchVesselIds"
              multiple
              :closeOnSelect="false"
              :clearable="false"
              :options="optionVessels"
              name="searchVesselIds"
              class="w-full pr-4"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            >
              <template v-slot:no-options>船舶が見つかりません。</template>
            </v-select>
          </vs-col>
          <vs-col vs-w="2">
            <vs-button @click="onSearch" color="primary">検索</vs-button>
          </vs-col>
        </vs-row>
      </div>

      <ag-grid-vue
        v-if="histories"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="histories"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        @grid-ready="onGridReady"
        @rowClicked="onClickRow"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

      <vs-popup
        class="voyage-history-popup aisea-text-14-400-black"
        title="航海記録"
        :active.sync="popupActive"
        color="#2d9cdb"
      >
        <p>この航海はまだ終了していないため、再生できません。</p>
        <div class="button-area">
          <vs-button
            class="aisea-text-14-400-white popup-button"
            color="#2d9cdb"
            @click="popupActive = false"
            >OK
          </vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import VesselCellRendererLink from "@/views/enterprise/management/vessels/vessel-list/cell-renderer/CellRendererLink.vue";
import { DateUtil } from "@/utils";
import _ from "lodash";
// v-select component
import vSelect from "vue-select";
import CellRendererTotalDistance from "./cell-renderer/CellRendererTotalDistance";
import CellRendererTotalSeconds from "./cell-renderer/CellRendererTotalSeconds";
import CellRendererUserName from "./cell-renderer/CellRendererUserName";
import CellRendererVesselName from "./cell-renderer/CellRendererVesselName";

const INITIAL_PAGE_SIZE = 10;

export default {
  name: "VoyageHistoryList",
  components: {
    vSelect,
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    VesselCellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererTotalDistance,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererTotalSeconds,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererUserName,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVesselName,
  },
  computed: {
    ...mapState({
      session: state => state.session.session,
      pageable: state => state.enterpriseVoyageHistory.pageable,
      projectEnterpriseId: state => state.voyageHistory.project.enterpriseId,
      defaultImage: function() {
        return "no_image_ship_s";
      },
    }),
    ...mapGetters({
      voyageHistories: "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      users: "enterpriseVoyageHistory/getSearchUsers",
      vessels: "enterpriseVoyageHistory/getSearchVessels",
    }),
    optionUsers() {
      return this.users.flatMap(d => {
        return { label: d.name || d.name_en, value: d.user_id };
      });
    },
    optionVessels() {
      return this.vessels.flatMap(d => {
        return { label: d.name_ja || d.name, value: d.id };
      });
    },
    paginationPageSize() {
      return this.pageSize;
    },
    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },
    totalVoyageHistory() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
  },
  watch: {
    currentPage() {
      this.searchVoyageHistories();
    },
    voyageHistories: function(tmpHistories) {
      this.histories = _.cloneDeep(tmpHistories);
      for (let history of this.histories) {
        history.started_at = DateUtil.toYMDHm(history.started_at);
        history.ended_at = DateUtil.toYMDHm(history.ended_at);
      }
      if (!this.histories || !this.histories.length) {
        this.gridOptions.suppressNoRowsOverlay = false;
        this.gridOptions.api.showNoRowsOverlay();
      }
    },
  },
  data() {
    return {
      popupActive: false,
      currentPage: 1,
      // Search params
      searchVesselIds: [],
      searchUserIds: [],
      // AgGrid
      histories: [],
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "航海履歴が見つかりませんでした" },
        suppressNoRowsOverlay: true,
        context: {
          componentParent: this,
        },
      },
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      components: { VesselCellRendererLink },
      columnDefs: [
        {
          headerName: "ID",
          field: "id",
          width: 120,
        },
        {
          headerName: "開始日時",
          field: "started_at",
          width: 200,
        },
        {
          headerName: "終了日時",
          field: "ended_at",
          width: 200,
        },
        {
          headerName: "船舶名",
          field: "vessel",
          width: 200,
          cellRenderer: "CellRendererVesselName",
        },
        {
          headerName: "操船者名",
          field: "user",
          width: 200,
          cellRenderer: "CellRendererUserName",
        },
        {
          headerName: "操船時間",
          field: "total_seconds",
          width: 150,
          cellRenderer: "CellRendererTotalSeconds",
        },
        {
          headerName: "総走行距離",
          field: "total_distance",
          width: 150,
          cellRenderer: "CellRendererTotalDistance",
        },
      ],
      pageSize: INITIAL_PAGE_SIZE, // 一覧に表示するレコードの数
    };
  },
  created() {
    this.searchVoyageHistories();
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
    this.gridApi = this.gridOptions.api;

    await this.$store.dispatch("enterpriseVoyageHistory/getSearchInfo");
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    ...mapActions({
      getEnterpriseVoyageHistories:
        "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
      selectPlayHistoryId: "enterpriseVoyageHistory/selectPlayHistoryId",
      resetVoyageHistoryListState:
        "enterpriseVoyageHistory/resetVoyageHistoryListState",
    }),
    onSearch() {
      this.currentPage = 1;
      this.searchVoyageHistories();
    },
    searchVoyageHistories() {
      let requestParams = {
        user_ids: this.searchUserIds.flatMap(e => e.value),
        vessel_ids: this.searchVesselIds.flatMap(e => e.value),
        page: this.getCurrentPage(),
        limit: this.paginationPageSize,
      };
      this.$vs.loading();
      this.$store
        .dispatch(
          "enterpriseVoyageHistory/getEnterpriseVoyageHistories",
          requestParams
        )
        .catch(() => {
          this.$vs.loading.close();
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    onClickRow(params) {
      let vessel = this.voyageHistories[params.rowIndex].vessel;
      let startUtc = this.voyageHistories[params.rowIndex].started_at;
      const urlParamStartUtc = DateUtil.toMomentObj(startUtc)
        .utc()
        .format("YYYY-MM-DD-HH-mm-ss");
      if (!this.voyageHistories[params.rowIndex].ended_at) {
        this.popupActive = true;
        return;
      }
      let endUtc = this.voyageHistories[params.rowIndex].ended_at;
      this.$router.push({
        name: "voyage-history-player",
        query: {
          startUtc: urlParamStartUtc,
          id: params.data.id,
          vessel: vessel,
          timeRange: { startUtc: startUtc, endUtc: endUtc },
        },
      });
    },
    getCurrentPage() {
      return this.currentPage - 1;
    },
    onChangePageSize(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.searchVoyageHistories();
    },
    cleanup() {
      this.resetVoyageHistoryListState();
    },
  },
};
</script>

<style lang="scss">
.voyage-history-popup {
  .popup-button {
    margin-left: 10px;
  }

  .button-area {
    width: fit-content;
    margin-top: 20px;
    margin-left: auto;
  }
}
</style>
